<template>
<section>
  <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
    <thead>
      <tr>
        <td></td>
        <td>Registration</td>
        <td>Account</td>
        <td>Required</td>
        <td>Editable</td>
      </tr>
    </thead>
    <tbody>
      <tr v-for="field in fieldOrder" :key="field">
        <th>
          {{ field | humanize }}
        </th>
        <td>
          <b-checkbox v-model="value[field].registration"></b-checkbox>
        </td>
        <td>
          <b-checkbox v-model="value[field].account"></b-checkbox>
        </td>
        <td>
          <b-checkbox v-model="value[field].required"></b-checkbox>
        </td>
        <td>
          <b-checkbox v-model="value[field].editable"></b-checkbox>
        </td>
      </tr>
    </tbody>
  </table>
</section>
</template>

<script>
export default {
  name: 'c-user-fields',
  props: ['value'],
  data() {
    return {
      fieldOrder: [
        'username',
        'password',
        'gender',
        'firstName',
        'lastName',
        'birthday',
        'currency',
        'code',
        'country',
        'city',
        'zip',
        'street',
        'email',
        'phone',
        'acceptTerms',
      ],
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Projects/Form/Custom/UserFields.vue